<div style="padding: 1.2rem 0 0.8rem 0">
    <span class="table-header-wrapper">
        <!-- <b *ngIf="count?.length && count.length < 50 && !page"
            >Liste des {{ count.length }} {{ legende }}</b
        >
        <b *ngIf="count?.length && count.length < 50 && page"
            >Liste des {{ count?.length }} {{ legende }}
            <span *ngIf="page"
                >[Page
                <span style="color: #009fff; margin-left: 0.2rem">{{
                    page
                }}</span
                >/{{ totalPage }}]</span
            ></b
        >-->
        <b *ngIf="count?.length && count.length > 0">
            Resultat du filtre
            <span class="text-success"> {{ total }}</span
            >&nbsp;
            <span *ngIf="page"
                >[Page
                <span style="color: #009fff; margin-left: 0.2rem">{{
                    page
                }}</span
                >/{{ totalPage }}]</span
            >
        </b>
        <b *ngIf="!count?.length || count.length === 0">
            Resultat du filtre {{ legende }}
        </b>
    </span>
</div>
